<div class="app-container">
  <app-header [hideHeader]="hideHeader"></app-header>
  <app-sidenav *ngIf="!hideHeader">
    <main [class.logged]="isLogged">
      <router-outlet></router-outlet>
    </main>
  </app-sidenav>

  <main *ngIf="hideHeader" [class.logged]="isLogged" class="full-width">
    <router-outlet></router-outlet>
  </main>

  <app-footer *ngIf="!hideHeader"></app-footer>
</div>

<app-loader></app-loader>

<app-cookie-acceptance *ngIf="isLogged"></app-cookie-acceptance>
<app-consent-acceptance *ngIf="isLogged"></app-consent-acceptance>

<app-uniben-notification></app-uniben-notification>
